import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateBusiness from "../../../../components/@business/UpdateBusiness";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function BusinessUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateBusiness
                routeType={routeType}
            />
        </SettingFrame>
    )
}